import i18n from '~/locales/i18n'

export const communicationsSnapshotColumns = [
  {
    id: 'expandConversationThread',
    label: '',
  },
  {
    id: 'lastMessageDate',
    label: i18n.t('Common:LAST_MESSAGE'),
  },
  {
    id: 'messageSubject',
    label: '',
  },
  {
    id: 'linkedAppointment',
    label: i18n.t('Clients:COMMUNICATION_WIDGET.LINKED'),
  },
]
